export const REQUEST_EXPERT_EXPERTISE_MISSIONS =
  'REQUEST_EXPERT_EXPERTISE_MISSIONS';
export const SET_EXPERT_EXPERTISE_MISSIONS = 'SET_EXPERT_EXPERTISE_MISSIONS';
export const RESET_STORE_EXPERTISE = 'RESET_STORE_EXPERTISE';
export const STATUS_IN_PROGRESS_MISSION_ID = 1;
export const STATUS_TREATED_MISSION_ID = 2;
export const STATUS_REJECTED_MISSION_ID = 3;
export const STATUS_PENDING_MISSION_ID = 4;
export const STATUS_ACHIEVED_MISSION_ID = 5;
export const STATUS_PENDING_APPRECIATION_MISSION_ID = 6;
export const STATUS_REJECTED_BY_EXPERT_MISSION_ID = 7;
export const STATUS_DECLINE_EXPERTISE_MISSION_ID = 8;
export const STATUS_PV_DEFICIENCY_MISSION_ID = 9;
